export const toCurrency = (value) => Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value))

export const toPercent = (value) => Intl.NumberFormat('pt-BR', { style: 'percent', maximumFractionDigits: 2 }).format(Number(value))

export const toNumber = (value) => Number(value.replace(/\D/g, '')) / 100;